<template>
<section class="section">
    <nav>
      <div class="tabs is-centered">
        <div class="ml-auto mr-auto">
          <ul v-if="currentUser.isAdmin" style="padding-left: 0;">
            <li :class="{'is-active': activeTab === 'list'}"><a @click="showTab('list')">List</a></li>
            <li :class="{'is-active': activeTab === 'createNoCard'}"><a @click="showTab('createNoCard')">Create new user (no card)</a></li>
          </ul>
        </div>
      </div>
    </nav>
    <div>
      <section v-if="activeTab === 'list'" class="section pt15">
        <user-list/>
      </section>
      <section v-if="activeTab === 'createNoCard' && currentUser.isAdmin" class="section pt15">
        <create-user-no-card/>
      </section>
    </div>
</section>
</template>

<script>
import UserList from './List.vue'
import CreateUserNoCard from './CreateUserNoCard.vue'

export default {
  components: {
    UserList,
    CreateUserNoCard,
  },
  data () {
    return {
      activeTab: 'list',
    }
  },
  methods: {
    showTab (tab) {
      this.activeTab = tab
    }
  },
  computed: {
    currentUser() {
      if (this.$store.state.user) {
        return this.$store.state.user
      }
      return {}
    }
  },
}
</script>

<style lang="scss">

</style>
